import AuthSignInTabComponent from "./AuthSignInTabComponent";

export default AuthSignInTabComponent;
